import { ButtonText } from '@/components/common/Button'
import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { useCardsphereExport } from '@/hooks/useCardsphereExport'

import { type DecklistBuyButtonType } from '../DecklistBuyLinks'

type Props = {
  buttonProps: DecklistBuyButtonType
  decklist: string[]
}

export const DecklistBuyLinkCardsphere = ({ buttonProps, decklist }: Props) => {
  const { loading, onClick } = useCardsphereExport({ decklist, medium: 'decklist' })

  return (
    <ButtonText {...buttonProps} disabled={loading} onClick={onClick}>
      <IconWithLabel iconBefore={loading ? 'spinner' : 'brand-cardsphere'}>Buy at Cardsphere</IconWithLabel>
    </ButtonText>
  )
}
